import { render, staticRenderFns } from "./VueScheduler.vue?vue&type=template&id=67383518&scoped=true&"
import script from "./VueScheduler.vue?vue&type=script&lang=js&"
export * from "./VueScheduler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67383518",
  null
  
)

export default component.exports